import { FC, SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {}

const IconlyUserIconFilled: FC<Props> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      {...props}
    >
      <path
        d="M9.99992 12.6449C13.6154 12.6449 16.6666 13.2324 16.6666 15.4991C16.6666 17.7666 13.5954 18.3333 9.99992 18.3333C6.38523 18.3333 3.33325 17.7458 3.33325 15.4791C3.33325 13.2116 6.4044 12.6449 9.99992 12.6449ZM9.99992 1.66666C12.4492 1.66666 14.4116 3.62834 14.4116 6.07587C14.4116 8.52339 12.4492 10.4859 9.99992 10.4859C7.5515 10.4859 5.58826 8.52339 5.58826 6.07587C5.58826 3.62834 7.5515 1.66666 9.99992 1.66666Z"
        fill={props.fill || "currentColor" || "#224788"}
      />
    </svg>
  );
};

export default IconlyUserIconFilled;
